import { useEffect, useState, MutableRefObject } from 'react';
import { PLACE_HOLDER } from '@zmedia/bm-soccer-ui/constants';

interface IProps {
    imgRef: MutableRefObject<null | HTMLImageElement>;
    src: string;
    alt?: string;
    intersectionObserverOptions?: IntersectionObserverInit;
}

export function useImage({
    imgRef,
    src,
    intersectionObserverOptions = {
        rootMargin: '100px',
    },
}: IProps): [string] {
    const [imgSrc, setImgSrc] = useState(PLACE_HOLDER.IMAGE);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setImgSrc(src);
                    observer.unobserve(entry.target);
                }
            });
        }, intersectionObserverOptions);

        if (imgRef && imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => {
            if (imgRef && imgRef.current) {
                observer.disconnect();
            }
        };
    }, [imgRef, src]);

    return [imgSrc];
}
